import UploadFile from './UploadFile.vue'
export default UploadFile



// WEBPACK FOOTER //
// ./src/components/ty-uploadfile/index.js